class Promotion {
    public name: string = '';
    public amount: number = 0;
    public description: string = '';
    public item_id: string = '';
    public max_per_occurrence: number = 0;
    public max_overall: number = 0;
    public start_date: string = '';
    public end_date: string = '';
    public status: string = '';
    public sub_type_restrictions: string[] = [];
    public qualifying_quantity: number = 0;
    public apply_to_quantity: number = 0;

    constructor(promotionData?: any) {
        if(promotionData) {
            for(let key in promotionData) {
                if (this.hasOwnProperty(key)) {
                    (<any>this)[key] = promotionData[key];
                }
            }
        }
    }
}

export default Promotion;